






































































































import {Component, Vue} from 'vue-property-decorator';
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {
	ServiceInvoice,
	ServiceInvoiceFilter, ServiceRecordDTO,
	UpdateInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import InvoiceCreationSlider from "@/components/payroll/business/services/invoice/InvoiceCreationSlider.vue";
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import {prettyEnum, subSrtIfNeed} from "../../../../../utils/StringUtils";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import ServiceInvoiceItem from "@/components/payroll/business/services/ServiceInvoiceItem.vue";
import DraftInvoicePreparer from "@/components/payroll/business/services/invoice/DraftInvoicePreparer.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import ServiceLogUpdateSlider from "@/components/payroll/business/services/service/ServiceLogUpdateSlider.vue";
import ServiceLogViewSlider from "@/components/payroll/business/services/service/ServiceLogViewSlider.vue";
import InvoiceCollapse from "@/components/payroll/business/services/invoice/InvoiceCollapse.vue";
import InvoiceService from "@/services/InvoiceService";
import InvoiceDTO, {InvoiceItem} from "@/dto/InvoiceDTO";

@Component({
	methods: {prettyEnum, subSrtIfNeed},
	components: {
		InvoiceCollapse,
		ServiceLogViewSlider,
		ServiceLogUpdateSlider,
		PaginationComponent,
		DraftInvoicePreparer,
		ServiceInvoiceItem,
		ServiceLogView, SingleFileHolder, BTPortalCollapse, EmbeddedFile, InvoiceCreationSlider}
})
export default class InvoiceList extends Vue {

	private draftInvoices: Page<InvoiceDTO<InvoiceItem>> = EMPTY_PAGE
	private invoices: Page<InvoiceDTO<InvoiceItem>> = EMPTY_PAGE

	private createInvoice = false;
	private draftInvoice = false
	private updateLog = false;
	private viewLog = false;

	private selectedInvoice: InvoiceDTO<InvoiceItem> | null = null;
	private selectedLog: ServiceRecordDTO | null = null;

	private filter = new ServiceInvoiceFilter(
		{
			payeeId: this.$wss.getCurrent.id
		}
	)

	openDraft(inv: ServiceInvoice) {
		this.selectedInvoice = inv
		this.draftInvoice = true
	}

	private deleteDraftInvoice(inv: ServiceInvoice): void {
		Application.startLoading()
		ServiceInvoiceOrchestrator.deleteDraftInvoice(inv.id).then(
			() => this.findInvoices(),
			err => processError(err, this)
		)
	}

	mounted() {
		Application.startLoading()
		Promise.all([this.loadInvoices(), this.loadDraftInvoices()])
			.finally(Application.stopLoading)
	}

	findInvoices() {
		Application.startLoading()
		Promise.all([this.loadInvoices(), this.loadDraftInvoices()])
			.finally(Application.stopLoading)
		this.$emit("reload")
	}

	loadInvoices() {
		let filter = new ServiceInvoiceFilter(this.filter)
		filter.size = 10
		filter.excludeStatus = "DRAFT"
		return InvoiceService.getPageByFilter(filter).then(
			res => {
				this.invoices = res.data
			},
			err => processError(err, this)
		)
	}

	loadDraftInvoices() {
		let filter = new ServiceInvoiceFilter(this.filter)
		filter.status = "DRAFT"
		filter.page = 0
		filter.size = 100
		return InvoiceService.getPageByFilter(filter).then(
			res => {
				this.draftInvoices = res.data
			},
			err => processError(err, this)
		)
	}

	private loadPage(page: number) {
		this.filter.page = page - 1
		this.findInvoices()
	}

	private loadNextPage() {
		this.filter.page = this.filter.page + 1
		this.findInvoices()
	}


	private openLog(log: ServiceRecordDTO, draft: boolean) {
		this.selectedLog = log
		if (!draft) {
			this.viewLog = true;
		} else {
			this.updateLog = true;
		}
	}


}
